require('./city-data-block.less');

jQuery(function() {
    $('.js-city-guess-hide').click(function() {
        $.ajax({
            url: '/ajax/action/region_widget/setCookie/',
            data: 'code=' + $(this).data('code')
        });
        $(this)
            .closest('.city-data-block__city-guess')
            .fadeOut(300);
    });
});



// WEBPACK FOOTER //
// ./blocks/city-data-block/city-data-block.js